import React, { useEffect, useState } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "assets/svgIcons/CloseIcon";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import CheckAdminIcon from "assets/svgIcons/CheckedAdminIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import SettingIconNew from "assets//svgIcons/SideNav/Settings";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { ChangeSettingModalWrapper } from "pages/Fleet/Cars/SortByHeader/SortByHeaderStyled";
import {
  MAP_GLOBAL_STATES,
  COMMON_COMPONENTS_STATES,
  FLEET_GLOBAL_STATES,
  SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import { useCarSettingsData } from "_helperFunctions/carSettings";
import LockIcon from "assets/svgIcons/LockIcon";
import UnLockIcon from "assets/svgIcons/UnlockIcon";
import UncheckedIcon from "assets/svgIcons/UncheckIcon";
import { Button } from "@mui/material";

const CarSettingsNew = () => {
  const { t } = useTranslation();
  const {
    showTaggedCarArrayNew,
    showSpeedCar,
    showDistanceCar,
    showCarType,
    showMaxHolesCar,
    showTaggedGpsArray
  } = useHookstate(MAP_GLOBAL_STATES);

  const { showTagCarsStatenew } = useHookstate(
    COMMON_COMPONENTS_STATES
  );

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  let txt = "";

  const { canEnable, canStage } = useCarSettingsData();
  const tx2new = txt.substring(0, txt.length - 1);
  const { selectFleetCarsData2 } = useHookstate(FLEET_GLOBAL_STATES);
  const [stagedCars2] = useState([]);
  const [enabledCars2] = useState([]);
  const speedNew = Object.values(showSpeedCar.get());
  const CarTypeNew = Object.values(showCarType.get());
  let speed = showSpeedCar.get()[0];
  let Units = showDistanceCar.get()[0];
  const DistanceData = Object.values(showDistanceCar.get());
  const allEqualSpeed = (arr) => arr.every((v) => v === arr[0]);
  const SpeedData = allEqualSpeed(speedNew);
  const allEqualCarType = (arr) => arr.every((v) => v === arr[0]);
  const CarTypeData = allEqualCarType(CarTypeNew);
  const allEqualDistanceData = (arr) => arr.every((v) => v === arr[0]);
  const [distanceEnabled, setDistanceEnabled] = useState(false);
  const CarDistanceData = allEqualDistanceData(DistanceData);
  const [deregister, setDeregister] = React.useState(false);
  const [stage10Cars, setStage10Cars] = React.useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [newCarType, setCarType] = React.useState(renderCarName());
  const [speedLimit, setSpeedLimit] = React.useState(speed);

  let Holes = showMaxHolesCar.get()[0];

  useEffect(() => {
    if(selectFleetCarsData2.get()?.length !== 0) {
         selectFleetCarsData2.get().map((item) => {
          if (canStage(item)) {
            stagedCars2.push(item);
          }
          if (canEnable(item)) {
            enabledCars2.push(item);
          }
        });
      }
  }, []);

  function MxnumberOfHoles() {
    if (Holes == -1) {
      return -1;
    } else if (Holes == 9) {
      return 9;
    } else if (Holes == 18) {
      return 18;
    } else {
      return 0;
    }
  }

  function renderCarName() {
    switch(showCarType.get()[0])
    {
      case 1:
        return "Fleet Car";
      case 2:
        return "Marshal Car";
      case 3:
        return "Special Need Car";
      case 4:
        return "Beverage Car";
      case 5:
      return "Out of service";
      case 6:
        return "Not In Use Car";
      default:
        return "Car name not available";
    }
  }

  function cartypecheck() {
    switch(newCarType)
    {
      case "Normal":
        return 0;
      case "Fleet Car":
        return 1;
      case "Marshal Car":
        return 2;
      case "Special Need Car":
        return 3;
      case "Beverage Car":
        return 4;
      default:
        return <span className="card-view">Car name not available</span>;
    }
  }

  const CarTypeHandle = (e) => {
    setActiveButton(true);
    setCarType(e.target.value);
  };

  const handleSpeedLimit = (e) => {
    setActiveButton(true);
    setSpeedLimit(e.target.value);
  };

  const [distance, setDistance] = React.useState(Units);
  const [sameyardsDistance, setyardsDistance] = React.useState(false);
  const [samemetersDistance, setmetersDistance] = React.useState(false);
  const yardsHandle = () => {
    setActiveButton(true);
    setDistance(1);
    setyardsDistance(false);
    setmetersDistance(true);
  };
  const metersHandle = () => {
    setActiveButton(true);
    setDistance(2);
    setmetersDistance(false);
    setyardsDistance(true);
  };
  const filtercartypedata = cartypecheck();
  const gpsiCarId = showTaggedGpsArray.get();
  const dispatch = useDispatch();

  const saveEntity = (e) => {
    setActiveButton(false);
    showTagCarsStatenew.set(false);
    showSpeedCar.set([]);
    showDistanceCar.set([]);
    showCarType.set([]);
    showMaxHolesCar.set([]);
    gpsiCarId.forEach((item) => {
      const payload = {
        GpsiCarId: item,
        CarType: filtercartypedata,
        MaxSpeed: speedLimit,
        MaxHolesAllowedCar: holes,
        DistanceUnits: distance,
      };
      dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
        dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
        dispatch(COMMON_SERVICES.getProductData(payload));
      });

      showTagCarsStatenew.set(false);
      showTaggedGpsArray.set([]);
    });
  };

  const handleClose = () => {
    setActiveButton(false);
    showTagCarsStatenew.set(false);
    showSpeedCar.set([]);
    showDistanceCar.set([]);
    showCarType.set([]);
    showMaxHolesCar.set([]);
    showTaggedGpsArray.set([]);
  };

  const [holes, setHoles] = React.useState(MxnumberOfHoles());
  const HolesChange = (e) => {
    setActiveButton(true);
    setHoles(e.target.value);
  };
  return (
    <ChangeSettingModalWrapper>
      <div className="heading">
        <h2>
          <span className="setting-icon-wrapper">
            <SettingIconNew color="#000" width={14} height={14} />
          </span>
          {showTaggedCarArrayNew.get().length > 1
            ? showTaggedCarArrayNew.get().length > 1 &&
              showTaggedCarArrayNew.get().length < 5
              ? `Cars: ${tx2new}`
              : `${showTaggedCarArrayNew.get().length} Cars`
            : `Car: ${showTaggedCarArrayNew.get()}`}
        </h2>

        <CloseIcon onClick={handleClose} width={22} height={22} />
      </div>
      <DialogContent>
        <div className="select-wrapper">
          <p>{t("Max_Number_of_Holes")}</p>
          <FormControl size="small">
            <Select
              value={holes}
              defaultValue={holes}
              name="CarSetting"
              onChange={HolesChange}
              IconComponent={ExpandMoreIcon}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="-1">{t("Use_fleet_setting")}</MenuItem>
              <MenuItem value="9">9</MenuItem>
              <MenuItem value="18">18</MenuItem>
              <MenuItem value="0">{t("Unlimited")}</MenuItem>
            </Select>
          </FormControl>
        </div>
        {showTaggedCarArrayNew.get().length == 1 ? (
          <div className="select-wrapper">
            <p>{t("Car_type")}</p>
            <FormControl size="small">
              <Select
                value={newCarType}
                defaultValue={newCarType}
                name="CarType"
                onChange={CarTypeHandle}
                IconComponent={ExpandMoreIcon}
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value="Normal" style={{ display: "none" }}>
                  {t("Normal")}
                </MenuItem>
                <MenuItem value="Fleet Car">Fleet Car</MenuItem>
                <MenuItem value="Special Need Car">
                  {t("Special_needs_cars")}
                </MenuItem>
                <MenuItem value="Marshal Car">{t("Marshal_cars")}</MenuItem>
                <MenuItem value="Beverage Car">{t("Beverage_cars")}</MenuItem>
              </Select>
            </FormControl>
          </div>
        ) : (
          ""
        )}
        {showTaggedCarArrayNew.get().length != 1 ? (
          <div>
            {CarTypeData ? (
              <div className="select-wrapper">
                <p>{t("Car_type")}</p>
                <FormControl size="small">
                  <Select
                    value={newCarType}
                    defaultValue={newCarType}
                    name="CarType"
                    onChange={CarTypeHandle}
                    IconComponent={ExpandMoreIcon}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="Normal" style={{ display: "none" }}>
                      Normal
                    </MenuItem>
                    <MenuItem value="Fleet Car">Fleet Car</MenuItem>
                    <MenuItem value="Special Need Car">
                      {t("Special_needs_cars")}
                    </MenuItem>
                    <MenuItem value="Marshal Car">{t("Marshal_cars")}</MenuItem>
                    <MenuItem value="Beverage Car">
                      {t("Beverage_cars")}
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            ) : (
              <div className="select-wrapper">
                <p>{t("Car_type")}</p>
                <FormControl size="small">
                  <Select
                    value={newCarType}
                    defaultValue=""
                    name="CarType"
                    onChange={CarTypeHandle}
                    IconComponent={ExpandMoreIcon}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="Normal" style={{ display: "none" }}>
                      Normal
                    </MenuItem>
                    <MenuItem value="Fleet Car">Fleet Car</MenuItem>
                    <MenuItem value="Special Need Car">
                      {t("Special_needs_cars")}
                    </MenuItem>
                    <MenuItem value="Marshal Car">{t("Marshal_cars")}</MenuItem>
                    <MenuItem value="Beverage Car">
                      {t("Beverage_cars")}
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
          </div>
        ) : (
          ""
        )}
        {showSpeedCar.get().length == 1 ? (
          <div className="select-wrapper">
            <p>{t("Speed_limit")}</p>
            <FormControl size="small">
              <Select
                value={speedLimit}
                defaultValue={speedLimit}
                name="SpeedLimit"
                onChange={handleSpeedLimit}
                displayEmpty
                IconComponent={ExpandMoreIcon}
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value={0 | -1}>{t("Default")}</MenuItem>
                <MenuItem value={15}>15mph</MenuItem>
                <MenuItem value={14}>14mph</MenuItem>
                <MenuItem value={13}>13mph</MenuItem>
                <MenuItem value={12}>12mph</MenuItem>
                <MenuItem value={11}>11mph</MenuItem>
                <MenuItem value={10}>10mph</MenuItem>
                <MenuItem value={9}>9mph</MenuItem>
                <MenuItem value={8}>8mph</MenuItem>
                <MenuItem value={7}>7mph</MenuItem>
                <MenuItem value={6}>6mph</MenuItem>
                <MenuItem value={5}>5mph</MenuItem>
                <MenuItem value={4}>4mph</MenuItem>
                <MenuItem value={3}>3mph</MenuItem>
                <MenuItem value={2}>2mph</MenuItem>
              </Select>
            </FormControl>
          </div>
        ) : (
          ""
        )}
        {showSpeedCar.get().length != 1 ? (
          <div>
            {SpeedData ? (
              <div className="select-wrapper">
                <p>{t("Speed_limit")}</p>
                <FormControl size="small">
                  <Select
                    value={speedLimit}
                    defaultValue={speedLimit}
                    name="SpeedLimit"
                    onChange={handleSpeedLimit}
                    displayEmpty
                    IconComponent={ExpandMoreIcon}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value={0 | -1}>{t("Default")}</MenuItem>
                    <MenuItem value={15}>15mph</MenuItem>
                    <MenuItem value={14}>14mph</MenuItem>
                    <MenuItem value={13}>13mph</MenuItem>
                    <MenuItem value={12}>12mph</MenuItem>
                    <MenuItem value={11}>11mph</MenuItem>
                    <MenuItem value={10}>10mph</MenuItem>
                    <MenuItem value={9}>9mph</MenuItem>
                    <MenuItem value={8}>8mph</MenuItem>
                    <MenuItem value={7}>7mph</MenuItem>
                    <MenuItem value={6}>6mph</MenuItem>
                    <MenuItem value={5}>5mph</MenuItem>
                    <MenuItem value={4}>4mph</MenuItem>
                    <MenuItem value={3}>3mph</MenuItem>
                    <MenuItem value={2}>2mph</MenuItem>
                  </Select>
                </FormControl>
              </div>
            ) : (
              <div className="select-wrapper">
                <p>{t("Speed_limit")}</p>
                <FormControl size="small">
                  <Select
                    value={0}
                    defaultValue={0}
                    name="SpeedLimit"
                    onChange={handleSpeedLimit}
                    displayEmpty
                    IconComponent={ExpandMoreIcon}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value={0}>{t("Default")}</MenuItem>
                    <MenuItem value={15}>15mph</MenuItem>
                    <MenuItem value={14}>14mph</MenuItem>
                    <MenuItem value={13}>13mph</MenuItem>
                    <MenuItem value={12}>12mph</MenuItem>
                    <MenuItem value={11}>11mph</MenuItem>
                    <MenuItem value={10}>10mph</MenuItem>
                    <MenuItem value={9}>9mph</MenuItem>
                    <MenuItem value={8}>8mph</MenuItem>
                    <MenuItem value={7}>7mph</MenuItem>
                    <MenuItem value={6}>6mph</MenuItem>
                    <MenuItem value={5}>5mph</MenuItem>
                    <MenuItem value={4}>4mph</MenuItem>
                    <MenuItem value={3}>3mph</MenuItem>
                    <MenuItem value={2}>2mph</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
          </div>
        ) : (
          ""
        )}
        <div className="select-wrapper">
          <div>
            <p></p>

            {showTaggedCarArrayNew.get().length == 1 ? (
              <div className="group-btn-wrapper">
                <button
                  className={distance == 1 ? "active" : ""}
                  onClick={yardsHandle}
                >
                  {t("Yards")}
                </button>
                <button
                  className={distance != 1 ? "active" : ""}
                  onClick={metersHandle}
                >
                  {t("Metres")}
                </button>
              </div>
            ) : (
              ""
            )}

            {showTaggedCarArrayNew.get().length != 1 &&
              CarDistanceData == true ? (
              <div className="group-btn-wrapper">
                <button
                  className={distance == 1 ? "active" : ""}
                  onClick={yardsHandle}
                >
                  {t("Yards")}
                </button>
                <button
                  className={distance != 1 ? "active" : ""}
                  onClick={metersHandle}
                >
                  {t("Metres")}
                </button>
              </div>
            ) : (
              ""
            )}

            {showTaggedCarArrayNew.get().length != 1 &&
              CarDistanceData == false ? (
              <div className="group-btn-wrapper">
                <button
                  className={sameyardsDistance ? "active" : ""}
                  onClick={metersHandle}
                >
                  {t("Yards")}
                </button>
                <button
                  className={samemetersDistance ? "active" : ""}
                  onClick={yardsHandle}
                >
                  {t("Metres")}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="select-wrapper">
          <p>{t("Show/Hide_Distances")}</p>
          <FormControl size="small">
            <Select
              value={distanceEnabled}
              name="HideShowDistance"
              IconComponent={ExpandMoreIcon}
              onChange={(e) => {
                setActiveButton(true);
                setDistanceEnabled(e.target.value);
              }}
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="Hide Distances">{t("Hide_distances")}</MenuItem>
              <MenuItem value="Show Distances">{t("Show_Distances")}</MenuItem>
              <MenuItem value="Use Fleet Setting">
                {t("Use_fleet_setting")}
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="admin-only">
          <p>{t("Admin_Only")}</p>
          <div>
            <div className="checkbox-wrapper for-admin-only">
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<UnCheckIcon />}
                    checked={deregister}
                    checkedIcon={<CheckAdminIcon />}
                    onClick={() => {
                      setActiveButton(true);
                      setDeregister(!deregister);
                    }}
                  />
                }
                label={t("Deregister_car")}
              />
            </div>
            {stagedCars2 &&
              stagedCars2.length !== 0 &&
              !stagedCars2.includes(undefined) ? (
              <div className="checkbox-wrapper flex-wrapper">
                <FormControlLabel
                  control={
                    <>
                      <Checkbox
                        icon={<UncheckedIcon />}
                        checkedIcon={<CheckIcon />}
                        checked={stage10Cars}
                        onClick={() => {
                          setActiveButton(true);
                          setStage10Cars(!stage10Cars);
                        }}
                      />
                      <LockIcon className="mr-5" />
                    </>
                  }
                  label={
                    stagedCars2 && stagedCars2.length == 1
                      ? `${t("Stage_car")} : ${stagedCars2 && stagedCars2[0]?.CarNumber
                      }`
                      : `Stage ${stagedCars2 && stagedCars2.length} cars`
                  }
                />
              </div>
            ) : (
              <></>
            )}

            {enabledCars2 &&
              enabledCars2.length !== 0 &&
              !enabledCars2.includes(undefined) ? (
              <div className="checkbox-wrapper flex-wrapper">
                <FormControlLabel
                  control={
                    <>
                      <Checkbox
                        icon={<UncheckedIcon />}
                        checkedIcon={<CheckIcon />}
                        checked={stage10Cars}
                        onClick={() => {
                          setActiveButton(true);
                          setStage10Cars(!stage10Cars);
                        }}
                      />
                      <UnLockIcon className="mr-5" />
                    </>
                  }
                  label={
                    enabledCars2 && enabledCars2.length >= 1
                      ? `${t("Enable_car")} : ${enabledCars2 && enabledCars2[0]?.CarNumber
                      }`
                      : `Enable ${enabledCars2 && enabledCars2.length} cars`
                  }
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="action-buttons">
          <Button
            variant="outlined"
            className={activeButton ? "active" : "disabled"}
            onClick={saveEntity}
          >
            <span> {t("Save")}</span>
          </Button>
          <Button onClick={handleClose}>{t("Cancel")}</Button>
        </div>
      </DialogActions>
    </ChangeSettingModalWrapper>
  );
};

export default CarSettingsNew;
